// src/components/layout/FooterGradient.jsx
import React from "react";
import { Link } from "react-router-dom";
import { FaPhone, FaInstagram, FaFacebook, FaLinkedin, FaGlobe, FaEnvelope, FaHeart } from "react-icons/fa";
import DownloadApple from "../../images/download-apple.png";
import DownloadAndroid from "../../images/download-android.png";

export default function FooterGradient() {
  return (
    <footer className="mt-12">
      <div className="relative text-center text-white px-6 sm:px-10 pt-16 sm:pt-24 lg:pt-28 pb-24 max-w-[1519px] mx-auto">
        <div className="absolute inset-0 bg-gradient-to-b from-[#FDE6F1] via-[#F4A7C9] to-[#E16AA1] rounded-t-[28px]" />

        <div className="relative text-center text-white px-6 sm:px-10 pt-16 sm:pt-24 lg:pt-28 pb-24">
          <h2 className="text-3xl sm:text-5xl lg:text-6xl font-asap font-semibold">
            Rejoins le mouvement dès maintenant
          </h2>
          <p className="mt-4 text-white/90 max-w-2xl mx-auto text-sm sm:text-base">
            Télécharge PACTE l'application gratuite qui recense des offres locales et découvre tous les commerces partenaires autour de toi. Profite d’offres exclusives, cumule des points fidélité et reste informé des actus locales en un seul clic.
          </p>

          <div className="mt-8 sm:mt-10 flex items-center justify-center gap-4 sm:gap-6">
             <a target="_blank" href="https://apps.apple.com/app/id6746101122"><img src={DownloadApple} alt="Télécharger dans l'App Store" className="h-14 w-auto" /></a>
                            <a target="_blank" href="https://play.google.com/store/apps/details?id=com.claix.pacteclaixapp&pcampaignid=web_share"><img src={DownloadAndroid} alt="Télécharger dans le Play Store" className="h-14 w-auto" /></a>
          </div>
        </div>

        {/* Mentions collées en bas */}
        <div className="absolute bottom-0 left-0 w-full">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs sm:text-[13px] text-white/90 px-6 sm:px-10 py-4">
            <div>©2025 PACTE — Tous droits réservés — <Link to="/mentions-legales" className="hover:underline">Mentions légales</Link> — <Link to="/cgu" className="hover:underline">CGU</Link> </div>
            <div className="flex items-center gap-4">
          
              <Link target="_blank" to="https://www.facebook.com/people/PACTE/61564146676538/"><FaFacebook size={18}/></Link> 
              <Link target="_blank" to="https://www.instagram.com/pacte_claix_38"><FaInstagram size={18}/></Link>
              <Link target="_blank" to="https://www.linkedin.com/company/pacte-claix/"><FaLinkedin size={18}/></Link>
              <Link target="_blank" to="mailto:contact@pacte-claix.fr"><FaEnvelope size={18}/></Link>
              <Link target="_blank" to="tel:+33"><FaPhone size={14}/></Link>
              ·<a href="https://noxzi.fr" className="">Propulsé par <span className="underline font-bold">NoxZi</span></a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}